import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Generator } from '../topic-widgets/generator';
import { TopicWidgetProperties } from 'book-widgets/interfaces';

import css from '@holmescorp/book-widgets/css/topicpage.m.css';

const factory = create({ theme }).properties<TopicWidgetProperties>();

export const Figure = factory(({ properties, middleware: { theme } }) => {
	const { topicdata, additionalClasses = [] } = properties();
	const themeCss = theme.classes(css);

	return v('figure', { classes: [themeCss.figure, ...additionalClasses] }, [
		w(Generator, { widgetType: 'figure', skipTitle: false, insection: true, topic: topicdata as any })
	]);
});
